import { EVENTS } from '../utils/constants.js'
import publishUserData from '../applications/publishUserData.js'
import saveUserInLocalData from '../applications/saveUserInLocalData.js'
import getUserData from '../applications/getUserData.js'
import verifyUserExists from '../applications/verifyUserExists.js'
import createRiderIfMissing from '../applications/createRiderIfMissing.js'
import Commons from '@/shared/utils/commons.js'

class OnAppReady {
  static register(context) {
    context.events.handle(EVENTS.APP_READY, async payload => {

      setTimeout(() => {
        if (window.parent && window.parent !== window) {
          window.parent.postMessage({ name: 'SPLASH_HIDE' }, '*')
        }
      }, 1500)

      try {
        let userData = await getUserData(context)

        // 🔁 Restauration depuis Preferences si l'app se relance sans user en mémoire
        if (!userData?.id && Commons.isCapacitor()) {
          console.log('🔎 Tentative de restauration depuis Preferences...')
          const persistedUser = await Commons.requestUserDataFromPreferences()
          if (persistedUser?.id) {
            console.log('🔁 User restauré depuis Preferences:', persistedUser.id)
            await context.localRepo.save(persistedUser)
            userData = persistedUser
          }
        }

        saveUserInLocalData(context, userData)

        if (userData) {
          // Verify the rider still exists on the backend before publishing
          const stillExists = await verifyUserExists(context)
          if (stillExists) {
            publishUserData(context)

            // Vérifier si le riderId est présent, sinon créer le rider
            // (utile pour les comptes créés avant la mise en place de ce système)
            try {
              const riderId = await createRiderIfMissing(context)
              if (riderId) {
                console.log('[onAppReady] riderId synchronisé:', riderId)
              }
            } catch (riderError) {
              console.error(
                '[onAppReady] Erreur synchro rider (non bloquant):',
                riderError,
              )
            }
          }
          // If not, verifyUserExists already dispatched LOGOUT_REQUESTED
        }
      } catch (error) {
        context.sendBugAlert(error)
      }
    })
  }
}
export default OnAppReady
